import { render } from "./ChildGrowthRecordRow.vue?vue&type=template&id=47ec224f&scoped=true&ts=true"
import script from "./ChildGrowthRecordRow.vue?vue&type=script&lang=ts"
export * from "./ChildGrowthRecordRow.vue?vue&type=script&lang=ts"

import "./ChildGrowthRecordRow.vue?vue&type=style&index=0&id=47ec224f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ec224f"]])

export default __exports__